import React from 'react'
import { useSelector } from 'react-redux'
import { FormGroup } from 'components/ui/form/renderers'
import styles from './fieldTextWithPreview.module.css'

/**
 * Custom Fee Message Preview Component
 * Shows a live preview of how the custom fee message will appear at checkout
 */
export const CustomFeeMessagePreview = ({ value, placeholder, currencySymbol = '$' }) => {
    const displayText = value || placeholder

    return (
        <div className={styles.preview}>
            <p className={styles.previewLabel}>Here's an example:</p>
            <div className={styles.previewBox}>
                <div className={styles.previewRadio} />
                <div className={styles.previewContent}>
                    <p className={styles.previewText}>
                        <span className={styles.previewPrice}>{currencySymbol}0.00</span>
                        <span className={styles.previewMethod}>Carrier - Method</span>
                        {displayText && (
                            <span className={styles.previewMessage}> {displayText}</span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    )
}

/**
 * Text input field with live preview for custom fee messages
 * Used in the surcharge rule builder form
 */
export const fieldTextWithPreview = (options) => {
    const {
        error,
        title,
        input,
        meta,
        hint,
        disabled,
        fullWidth,
        className,
        oneLine,
        readOnly,
        required,
        hideTitleAndHint,
        prefix,
    } = options

    const { app: { user_settings: { currency_symbol = '$' } = {} } = {} } =
        useSelector((state) => state)

    return (
        <>
            <FormGroup
                error={error}
                meta={meta}
                label={title}
                name={input.name}
                hint={hint}
                fullWidth={fullWidth}
                className={className}
                oneLine={oneLine}
                required={required}
                hideTitleAndHint={hideTitleAndHint}
                prefix={prefix}
            >
                <input
                    className="form-control string optional"
                    readOnly={readOnly || disabled}
                    placeholder={options.placeholder}
                    {...input}
                    id={`field-${input.name}`}
                    type="text"
                    {...(required ? { 'aria-required': 'true' } : null)}
                />
            </FormGroup>
            <CustomFeeMessagePreview
                value={input.value}
                placeholder={options.placeholder}
                currencySymbol={currency_symbol}
            />
        </>
    )
}

export default fieldTextWithPreview
